import axios from "axios";
import session from '../session.js'
import cache from '../cache/index.js'
import {getApiDomain} from '../index.js'

const service = axios.create({
  // baseURL: process.env.NODE_ENV !== 'production'?process.env.VUE_APP_BASE_API :process.env.VUE_APP_BASE_API_RUL
  baseURL: getApiDomain()
});



// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
service.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json;charset=utf-8";
    config.headers["Access-Token"] = session.getLoginToken(); // 设置请求头
    config.headers["X-User-Id"] = session.getUserId(); // 设置请求头
    config.headers["X-Game-Code"] = cache.getGameCode(); // 设置请求头
    config.headers["X-Auth-Token"] = session.getLoginToken(); // 设置请求头 
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response 拦截器
// 可以在接口响应后统一处理结果
service.interceptors.response.use(
  (response) => {
    // console.log("-----------response---------------", response);
    let res = response.data;
    // if (res.exception) {
    //   Message.error(exception);
    //   return;
    // }
    // 如果是返回的文件
    if (response.config.responseType === "blob") {
      return res;
    }

    // 兼容服务端返回的字符串数据
    if (typeof res === "string") {
      res = res ? JSON.parse(res) : res;
    }
    return res;
  },
  (error) => {
    if (!error.config || !error.config.silentError) {
      alert("网络异常,请稍后再试" + error);
    }
    return Promise.reject(error);
  }
);

export default service;
